// 台灣縣市行政區資料（包含經緯度座標）
export const citiesAndDistricts = [
  {
    city: '台北市',
    cityEn: 'Taipei City',
    districts: [
      { name: '中正區', nameEn: 'Zhongzheng District', lat: 25.0329, lng: 121.5182 },
      { name: '大同區', nameEn: 'Datong District', lat: 25.0633, lng: 121.5131 },
      { name: '中山區', nameEn: 'Zhongshan District', lat: 25.0642, lng: 121.5328 },
      { name: '松山區', nameEn: 'Songshan District', lat: 25.0497, lng: 121.5578 },
      { name: '大安區', nameEn: 'Daan District', lat: 25.0263, lng: 121.5436 },
      { name: '萬華區', nameEn: 'Wanhua District', lat: 25.0319, lng: 121.4989 },
      { name: '信義區', nameEn: 'Xinyi District', lat: 25.0308, lng: 121.5745 },
      { name: '士林區', nameEn: 'Shilin District', lat: 25.0936, lng: 121.5162 },
      { name: '北投區', nameEn: 'Beitou District', lat: 25.1316, lng: 121.5015 },
      { name: '內湖區', nameEn: 'Neihu District', lat: 25.0826, lng: 121.5908 },
      { name: '南港區', nameEn: 'Nangang District', lat: 25.0546, lng: 121.6072 },
      { name: '文山區', nameEn: 'Wenshan District', lat: 24.9889, lng: 121.5707 }
    ]
  },
  {
    city: '新北市',
    cityEn: 'New Taipei City',
    districts: [
      { name: '板橋區', nameEn: 'Banqiao District', lat: 25.0092, lng: 121.4595 },
      { name: '三重區', nameEn: 'Sanchong District', lat: 25.0608, lng: 121.4882 },
      { name: '中和區', nameEn: 'Zhonghe District', lat: 24.9999, lng: 121.4966 },
      { name: '永和區', nameEn: 'Yonghe District', lat: 25.0083, lng: 121.5161 },
      { name: '新莊區', nameEn: 'Xinzhuang District', lat: 25.0358, lng: 121.4325 },
      { name: '新店區', nameEn: 'Xindian District', lat: 24.9675, lng: 121.5417 },
      { name: '樹林區', nameEn: 'Shulin District', lat: 24.9937, lng: 121.4204 },
      { name: '鶯歌區', nameEn: 'Yingge District', lat: 24.9545, lng: 121.3535 },
      { name: '三峽區', nameEn: 'Sanxia District', lat: 24.9346, lng: 121.3692 },
      { name: '淡水區', nameEn: 'Tamsui District', lat: 25.1678, lng: 121.4400 },
      { name: '汐止區', nameEn: 'Xizhi District', lat: 25.0673, lng: 121.6421 },
      { name: '瑞芳區', nameEn: 'Ruifang District', lat: 25.1091, lng: 121.8124 },
      { name: '土城區', nameEn: 'Tucheng District', lat: 24.9706, lng: 121.4418 },
      { name: '蘆洲區', nameEn: 'Luzhou District', lat: 25.0847, lng: 121.4741 },
      { name: '五股區', nameEn: 'Wugu District', lat: 25.0829, lng: 121.4383 },
      { name: '泰山區', nameEn: 'Taishan District', lat: 25.0574, lng: 121.4309 },
      { name: '林口區', nameEn: 'Linkou District', lat: 25.0768, lng: 121.3922 },
      { name: '深坑區', nameEn: 'Shenkeng District', lat: 25.0023, lng: 121.6157 },
      { name: '石碇區', nameEn: 'Shiding District', lat: 24.9947, lng: 121.6595 },
      { name: '坪林區', nameEn: 'Pinglin District', lat: 24.9362, lng: 121.7108 },
      { name: '三芝區', nameEn: 'Sanzhi District', lat: 25.2566, lng: 121.5009 },
      { name: '石門區', nameEn: 'Shimen District', lat: 25.2904, lng: 121.5668 },
      { name: '八里區', nameEn: 'Bali District', lat: 25.1449, lng: 121.3992 },
      { name: '平溪區', nameEn: 'Pingxi District', lat: 25.0256, lng: 121.7394 },
      { name: '雙溪區', nameEn: 'Shuangxi District', lat: 25.0355, lng: 121.8656 },
      { name: '貢寮區', nameEn: 'Gongliao District', lat: 25.0185, lng: 121.9090 },
      { name: '金山區', nameEn: 'Jinshan District', lat: 25.2186, lng: 121.6339 },
      { name: '萬里區', nameEn: 'Wanli District', lat: 25.1796, lng: 121.6889 },
      { name: '烏來區', nameEn: 'Wulai District', lat: 24.8658, lng: 121.5502 }
    ]
  }
];
